import { PRIORITY, TASK_STATUS } from "./enums";
import { ASSIGNEE_UNASSIGNED } from "./tasks-assignees";

export const TASK_RELATION_TYPE = {
  NONE: "none",
  LEAD: "lead",
  COMPANY: "company",
  CONTACT: "contact",
  DEAL: "deal",
};

export function getTaskPrimaryRelation(task) {
  if (task?.related_lead_id) return { type: TASK_RELATION_TYPE.LEAD, id: task.related_lead_id };
  if (task?.related_company_id) return { type: TASK_RELATION_TYPE.COMPANY, id: task.related_company_id };
  if (task?.related_contact_id) return { type: TASK_RELATION_TYPE.CONTACT, id: task.related_contact_id };
  if (task?.related_deal_id) return { type: TASK_RELATION_TYPE.DEAL, id: task.related_deal_id };
  return { type: TASK_RELATION_TYPE.NONE, id: "" };
}

export function getTaskRelationLink(relation, item) {
  if (!relation?.id || relation?.type === TASK_RELATION_TYPE.NONE) return null;
  if (relation.type === TASK_RELATION_TYPE.LEAD) {
    return { label: item?.title || "Lead oeffnen", to: `/leads/${relation.id}` };
  }
  if (relation.type === TASK_RELATION_TYPE.COMPANY) {
    return { label: item?.name || "Firma oeffnen", to: `/firmen/${relation.id}` };
  }
  if (relation.type === TASK_RELATION_TYPE.CONTACT) {
    return {
      label: getContactLabel(item) || "Kontakt oeffnen",
      to: `/kontakte/${relation.id}`,
    };
  }
  if (relation.type === TASK_RELATION_TYPE.DEAL) {
    return { label: item?.title || "Deal oeffnen", to: `/deals/${relation.id}` };
  }
  return null;
}

export function getTaskRelationDetailEndpoint(relation) {
  if (!relation?.id || relation?.type === TASK_RELATION_TYPE.NONE) return null;
  if (relation.type === TASK_RELATION_TYPE.LEAD) return `/api/leads/${relation.id}`;
  if (relation.type === TASK_RELATION_TYPE.COMPANY) return `/api/companies/${relation.id}`;
  if (relation.type === TASK_RELATION_TYPE.CONTACT) return `/api/contacts/${relation.id}`;
  if (relation.type === TASK_RELATION_TYPE.DEAL) return `/api/deals/${relation.id}`;
  return null;
}

export function isTaskOverdue(dueDateIso, status) {
  if (!dueDateIso) return false;
  if (status === TASK_STATUS.DONE || status === TASK_STATUS.CANCELLED) return false;
  const due = new Date(dueDateIso);
  if (Number.isNaN(due.getTime())) return false;
  const startToday = new Date();
  startToday.setHours(0, 0, 0, 0);
  return due < startToday;
}

export function isoToDateInput(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const yyyy = String(date.getFullYear());
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function dateInputToIso(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}

export function buildTaskDetailEditForm(task) {
  return {
    title: task?.title || "",
    description: task?.description || "",
    priority: task?.priority || PRIORITY.MEDIUM,
    status: task?.status || TASK_STATUS.OPEN,
    due_date: isoToDateInput(task?.due_date),
    assigned_user_id: task?.assigned_user_id || ASSIGNEE_UNASSIGNED,
  };
}

function getContactLabel(contact) {
  const fullName = `${contact?.first_name || ""} ${contact?.last_name || ""}`.trim();
  if (fullName) return fullName;
  if (contact?.email) return contact.email;
  return "";
}
